var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    opacity: 0.4,
    d: "M19.4301 7.23094L12.14 14.5209C11.94 14.7309 11.67 14.8409 11.39 14.8409H9.25V12.7009C9.25 12.4109 9.36006 12.1409 9.56006 11.9409L16.8501 4.65094C17.2701 4.23094 17.9501 4.23094 18.3601 4.65094L19.4301 5.72094C19.8501 6.14094 19.8501 6.82094 19.4301 7.23094Z",
    fill: "#D58B0E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0801 3H6C4.34 3 3 4.34 3 6V18C3 19.66 4.34 21 6 21H18C19.66 21 21 19.66 21 18V13M11.39 15.59H8.5V12.7C8.5 12.22 8.69003 11.75 9.03003 11.41L16.3201 4.12C17.0301 3.41 18.19 3.41 18.9 4.12L19.9701 5.19C20.6801 5.9 20.6801 7.06 19.9701 7.77L12.6801 15.06C12.3301 15.4 11.87 15.59 11.39 15.59Z",
    stroke: "#D58B0E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.c4611840ce22199d269b27f6419805c4.svg";
export { ForwardRef as ReactComponent };